import { LineItemAddDto } from 'src/items-list/business-logic/service/interfaces/line-item-add.dto';
import { EntryMethod } from '../../common/enumerations/entry-method';
import { IItemLookup } from '../../common/interfaces/dtos/IItemLookup';
import { IElectronicJournalRecord } from '../../common/interfaces/states/IElectronicJournalRecord';
import { handleTareWeightItems } from './handle-tare-weight-items';

export const handleTareModification = async (
  selectedItem: IElectronicJournalRecord,
): Promise<void> => {
  const lineItem: LineItemAddDto = {
    withData: false,
    item: {
      id: selectedItem.ItemId ?? '',
      entryMethod: EntryMethod.Automatic,
    },
    tareWeight: {
      isManualPercentage: !!selectedItem.TareWeight?.IsManualPercentage,
      tareValue: selectedItem.TareWeight?.TareValue || 0,
      isTareOverride: true,
      grossWeight: selectedItem.TareWeight?.GrossWeight || (selectedItem.Quantity ?? 0),
    },
    quantity: {
      value: selectedItem.Quantity ?? 0,
      entryMethod: EntryMethod.Automatic,
    },
    uomCode: selectedItem.UnitOfMeasureCode ?? '',
    sequenceNumber: selectedItem.SequenceNumber,
  };

  const itemLookup: IItemLookup = {
    itemId: selectedItem.ItemId,
    description: selectedItem.Name,
    unitsOfMeasure: selectedItem.UnitOfMeasureCode,
  };

  return handleTareWeightItems(lineItem, itemLookup);
};
